import React from "react";
import { CalendarPlus } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const pad = (n) => String(n).padStart(2, "0");
const stamp = (d) => `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

function range(e) {
  const [y, m, d] = e.date.split("-").map(Number);
  if (!e.time) {
    const s = new Date(Date.UTC(y, m - 1, d));
    const en = new Date(s); en.setUTCDate(en.getUTCDate() + 1);
    const f = (x) => `${x.getUTCFullYear()}${pad(x.getUTCMonth() + 1)}${pad(x.getUTCDate())}`;
    return { start: f(s), end: f(en), allDay: true };
  }
  const [hh, mm] = e.time.split(":").map(Number);
  const start = new Date(y, m - 1, d, hh, mm);
  const end = e.end_time && e.end_time > e.time
    ? new Date(y, m - 1, d, ...e.end_time.split(":").map(Number))
    : new Date(start.getTime() + 2 * 3600 * 1000);
  return { start: stamp(start), end: stamp(end), allDay: false };
}

function googleUrl(e, r, details, url) {
  const p = new URLSearchParams({ action: "TEMPLATE", text: e.title, dates: `${r.start}/${r.end}`, details: `${details}\n${url}`.trim(), location: e.location || "" });
  if (!r.allDay) p.set("ctz", "America/New_York");
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

function icsBlob(e, r, details, url) {
  const esc = (s) => String(s || "").replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/,/g, "\\,").replace(/;/g, "\\;");
  const dt = r.allDay ? `DTSTART;VALUE=DATE:${r.start}\nDTEND;VALUE=DATE:${r.end}` : `DTSTART:${r.start}\nDTEND:${r.end}`;
  const body = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Okuapemman Association of Massachusetts//EN", "BEGIN:VEVENT",
    `UID:${e.id}@okuapemmanma.org`, `DTSTAMP:${stamp(new Date())}`, dt, `SUMMARY:${esc(e.title)}`,
    `DESCRIPTION:${esc(details)}${url ? `\\n${url}` : ""}`, `LOCATION:${esc(e.location)}`, url ? `URL:${url}` : "", "END:VEVENT", "END:VCALENDAR"].filter(Boolean).join("\r\n");
  return new Blob([body], { type: "text/calendar;charset=utf-8" });
}

export function AddToCalendar({ event, compact = false, testId }) {
  const { t } = useLang();
  if (!event?.date) return null;
  const r = range(event);
  const url = `${window.location.origin}/events/${event.id}`;
  const details = event.description || "";
  const downloadIcs = () => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(icsBlob(event, r, details, url));
    a.download = `${event.title.replace(/[^\w]+/g, "-").toLowerCase()}.ics`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 2000);
  };
  const base = `inline-flex min-h-[36px] items-center gap-1 rounded-md border border-gold/50 px-3 py-1.5 text-xs font-semibold text-crimson transition-colors hover:bg-gold-light ${compact ? "" : "sm:text-sm"}`;
  return (
    <div className="flex flex-wrap gap-2" data-testid={testId || `add-to-calendar-${event.id}`}>
      <a href={googleUrl(event, r, details, url)} target="_blank" rel="noreferrer" className={base} data-testid={`cal-google-${event.id}`}><CalendarPlus size={14} /> {t("Google Calendar")}</a>
      <button type="button" onClick={downloadIcs} className={base} data-testid={`cal-ics-${event.id}`}><CalendarPlus size={14} /> {t("Apple / Outlook (.ics)")}</button>
    </div>
  );
}
